import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import RichTextEditor from "react-rte";

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#FCFCFC",
    },
}));

const StepFive = (props) => {
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["configuration"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["configuration"].toString("html"), "html") :
        RichTextEditor.createEmptyValue())
    const classes = useStyles();
    const {t} = useTranslation();
    const [supportField, setSupportField] = useState(props.publishDetail.publish_detail.support ? props.publishDetail.publish_detail.support : '');

    useEffect(() => {
        let valHtml = editorState.toString('html').replace(/(<([^>]+)>)/gi, "").trim()
        if (valHtml.length > 0 && (supportField.length > 0 || props.publishDetail.publish_detail.type === 'library' || props.publishDetail.publish_detail.type === 'action')) {
            props.setIsRequired(false)
        } else {
            props.setIsRequired(true)
        }
    }, [supportField, editorState])

    const handleChange = val => {

        setSupportField(val)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                support: val
            }
        }))
    }

    const handleEdit = value => {
        setEditorState(value)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                configuration: editorState
            }
        }))
    }

    return (
        <DialogContent style={{padding: "20px 0 0 0"}}>
            <div style={{textAlign: "left"}}>
                <Grid container>
                    {
                        props.publishDetail.publish_detail.type !== 'action' &&
                        <Grid item xs={12} style={{marginBottom: "1rem"}}>
                            <span className="dialog-text">{t('CONTENT.PUBLISH.SUPPORT')}</span>
                            <TextField
                                id="filled-size-small"
                                style={{float: "left"}}
                                value={supportField}
                                onChange={(e) => handleChange(e.target.value)}
                                className={classes.input}
                                variant="outlined"
                                size="small"
                                fullWidth
                            />
                        </Grid>
                    }
                    <Grid item xs={12}
                    >
                        <span className="dialog-text">{t('CONTENT.PUBLISH.CONFIGURATION')}</span>
                        <RichTextEditor
                            editorClassName="publish-editor"
                            value={editorState}
                            onChange={value => handleEdit(value)}
                        />
                    </Grid>

                </Grid>
            </div>
        </DialogContent>

    );
};

export default StepFive;
